/**
 * Authentication Utilities
 * Handles token generation, verification, and storage
 */

const TOKEN_KEY = 'incogniflex_auth_token';
const USER_KEY = 'incogniflex_user_data';

/**
 * Generate a token (simulated - in production, this comes from backend)
 */
export const generateToken = () => {
  return `token_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

/**
 * Get stored token from localStorage
 */
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

/**
 * Set token in localStorage
 */
export const setToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

/**
 * Get stored user data
 */
export const getUserData = () => {
  const data = localStorage.getItem(USER_KEY);
  return data ? JSON.parse(data) : null;
};

/**
 * Set user data in localStorage
 */
export const setUserData = (userData) => {
  localStorage.setItem(USER_KEY, JSON.stringify(userData));
};

/**
 * Check if user is authenticated
 */
export const isAuthenticated = () => {
  const token = getToken();
  return !!token;
};

/**
 * Verify token via API
 * In production, this would call /api/verify.php
 */
export const verifyToken = async (token) => {
  try {
    // Simulate API call - replace with real endpoint
    // const response = await fetch('/api/verify.php?token=' + token);
    // const data = await response.json();
    // return data.valid;
    
    // For now, we'll accept any token that exists
    return !!token;
  } catch (error) {
    console.error('Token verification failed:', error);
    return false;
  }
};

/**
 * Register user and get token
 * In production, this would call /api/register.php
 */
export const registerUser = async (name, email) => {
  try {
    // Simulate API call - replace with real endpoint
    // const response = await fetch('/api/register.php', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({ name, email })
    // });
    // const data = await response.json();
    // return { token: data.token, success: data.success };
    
    // For demonstration, generate a token locally
    const token = generateToken();
    const userData = { name, email, registeredAt: new Date().toISOString() };
    
    setToken(token);
    setUserData(userData);
    
    return { token, success: true, userData };
  } catch (error) {
    console.error('Registration failed:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Logout user
 */
export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};
